import { gql } from "@apollo/client";

export const EXCLUSIVE_PLAN_TYPE = gql`
  mutation BuildNowLandType($payload: ExclusivePlanLandTypeDto!) {
    buildNowLandType(payload: $payload)
  }
`;
